import { render, staticRenderFns } from "./BulkServicesReportBlock.vue?vue&type=template&id=4fc3e6a4&scoped=true&"
import script from "./BulkServicesReportBlock.vue?vue&type=script&lang=js&"
export * from "./BulkServicesReportBlock.vue?vue&type=script&lang=js&"
import style0 from "./BulkServicesReportBlock.vue?vue&type=style&index=0&id=4fc3e6a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc3e6a4",
  null
  
)

export default component.exports